<template>
  <v-menu bottom left offset-y min-width="200px">
    <template v-slot:activator="{ on: menu }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn icon v-on="{ ...tooltip, ...menu }">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('moreActions') }}</span>
      </v-tooltip>
    </template>

    <v-list dense>
      <v-list-item v-if="todo.canDelete" @click="delete_">
        <v-list-item-icon>
          <v-icon small>mdi-delete-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
           <v-list-item-title>{{ $t('delete') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>


<script>
export default {
  props: {
    todo: Object
  },


  methods: {
    delete_ () {
      this.$emit('delete', this.todo)
    }
  }
}
</script>
